var data = {
  "organizationCircles": {
    "id": "organizationCircles",
    "type": "circle",
    "source": {
      "type": "geojson"
    },
    "paint": {
      "circle-radius": 6,
      "circle-color":  "#FFCD00",
      "circle-stroke-width": 2,
      "circle-stroke-color": "#FFF",
      "circle-opacity": 0.8
    }
  },
  "organizations": {
     "id": "organizations",
     "type": "fill-extrusion",
     "source":{
       "type": "geojson"
     },
     "paint": {
       "fill-extrusion-color": "#FCE474",
       "fill-extrusion-height": 20,
       "fill-extrusion-opacity": 0.8
     }
  },
  "organizationLabels": {
    "id": "organizationLabels",
    "type": "symbol",
    "source": {
      "type": "geojson"
    },
    "layout": {
      "text-field": "{organizations_name}",
      "text-offset": [1, 0],
      "text-size": 9,
      "text-anchor": "left",
      "text-justify": "left"
    },
    "paint": {
      "text-color": "#666",
      "text-halo-color": "#fff",
      "text-halo-width": 1,
      "text-halo-blur": 1,
    }
  },
  "bartTracks": {
     "id": "bartTracks",
     "type": "line",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.1af1g5m2"
     },
     "source-layer": "tracks-czl7cf",
     "layout": {
       "line-join": "round",
       "line-cap": "round"
     },
     "paint": {
       "line-color": "#787058",
       "line-width": 12,
       "line-opacity": 0.2
     }
  },
  "bartStations": {
     "id": "bartStations",
     "type": "circle",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.cxzyo2hb"
     },
     "source-layer": "stations-6l2yft",
     "paint": {
       "circle-radius": 10,
       "circle-color": "#787058",
       "circle-stroke-width": 2,
       "circle-opacity": 0.5,
       "circle-stroke-color": "rgba(255,255,255, 1)"
     },
     "popup": {
       "title": "BART Station",
       "content": "{name}"
     }
  },
  "muni": {
     "id": "muni",
     "type": "line",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.cnquv1nd"
     },
     "filter": ['==', 'status', 'Existing'],
     "source-layer": "muni_light_rail-d4j1d1",
     "layout": {
       "line-join": "round",
       "line-cap": "round"
     },
     "paint": {
       "line-color": "#787058",
       "line-width": 4,
       "line-opacity": 0.6
     }
  },
  "muniPlanned": {
     "id": "muniPlanned",
     "type": "line",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.cnquv1nd"
     },
     "filter": ['==', 'status', 'Planned'],
     "source-layer": "muni_light_rail-d4j1d1",
     "layout": {
       "line-join": "round",
       "line-cap": "round"
     },
     "paint": {
       "line-color": "#787058",
       "line-width": 4,
       "line-dasharray": [2,4],
       "line-opacity": 0.6
     }
  },
  "muniBRTPlanned": {
     "id": "muniBRTPlanned",
     "type": "line",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.cjt70whm"
     },
     "filter": ['==', 'status', 'Planned'],
     "source-layer": "muni_brt-bos3ox",
     "layout": {
       "line-join": "round",
       "line-cap": "round"
     },
     "paint": {
       "line-color": "#787058",
       "line-width": 4,
       "line-dasharray": [1,1.5],
       "line-opacity": 0.6
     }
  },
  "busRoutes": {
     "id": "busRoutes",
     "type": "line",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.87352vr4"
     },
     "source-layer": "routes-28vq3y",
     "layout": {
       "line-join": "round",
       "line-cap": "round"
     },
     "paint": {
       "line-color": "#787058",
       "line-width": 2,
       "line-opacity": 0.3
     }
  },
  "busStops": {
     "id": "busStops",
     "type": "circle",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.aw9db494"
     },
     "source-layer": "stops-1ou0h2",
     "paint": {
       "circle-radius": 3,
       "circle-color": "rgba(95, 173, 196, 0.8)",
       "circle-stroke-width": 2,
       "circle-stroke-color": "rgba(255,255,255, 0.8)"
     }
  },
  "bikeways": {
     "id": "bikeways",
     "type": "line",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.1lwk2jwd"
     },
     "source-layer": "SFMTA_Bikeway_Network-assjfg",
     "layout": {
       "line-join": "round",
       "line-cap": "round"
     },
     "paint": {
       "line-color": "#787058",
       "line-width": 3,
       "line-dasharray": [0.1,3],
       "line-opacity": 0.6
     }
  },
  "caltrain": {
     "id": "caltrain",
     "type": "line",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.7n1dp9te"
     },
     "filter": ['==', 'status', 'Existing'],
     "source-layer": "caltrain-a7n0pa",
     "layout": {
       "line-join": "round",
       "line-cap": "round"
     },
     "paint": {
       "line-color": "#787058",
       "line-width": 8,
       "line-opacity": 0.6
     }
  },
  "caltrainPlanned": {
     "id": "caltrainPlanned",
     "type": "line",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.7n1dp9te"
     },
     "filter": ['==', 'status', 'Planned'],
     "source-layer": "caltrain-a7n0pa",
     "layout": {
       "line-join": "round",
       "line-cap": "round"
     },
     "paint": {
       "line-color": "#787058",
       "line-width": 8,
       "line-dasharray": [1,1.5],
       "line-opacity": 0.6
     }
  },
  "zoningPublic": {
     "id": "zoningPublic",
     "type": "fill",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.6scm5xi4"
     },
     "source-layer": "Zoning_Districts-1l54mp",
     "filter": ['==', 'gen', 'Public'],
     "paint": {
       "fill-color": 'rgba(241, 60, 42, 0.2)',
       "fill-opacity": 1
     }
  },
  "zoningResidential": {
     "id": "zoningResidential",
     "type": "fill",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.6scm5xi4"
     },
     "source-layer": "Zoning_Districts-1l54mp",
     "filter": ['==', 'gen', 'Residential'],
     "paint": {
       "fill-color": 'rgba(241, 60, 42, 0.2)',
       "fill-opacity": 1
     }
  },
  "zoningComercial": {
     "id": "zoningComercial",
     "type": "fill",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.6scm5xi4"
     },
     "source-layer": "Zoning_Districts-1l54mp",
     "filter": ['==', 'gen', 'Commercial'],
     "paint": {
       "fill-color": 'rgba(241, 60, 42, 0.2)',
       "fill-opacity": 1
     }
  },
  "zoningMixeduse": {
     "id": "zoningMixeduse",
     "type": "fill",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.6scm5xi4"
     },
     "source-layer": "Zoning_Districts-1l54mp",
     "filter": ['==', 'gen', 'Mixed Use'],
     "paint": {
       "fill-color": 'rgba(241, 60, 42, 0.2)',
       "fill-opacity": 1
     }
  },
  "zoningIndustrial": {
     "id": "zoningIndustrial",
     "type": "fill",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.6scm5xi4"
     },
     "source-layer": "Zoning_Districts-1l54mp",
     "filter": ['==', 'gen', 'Industrial'],
     "paint": {
       "fill-color": 'rgba(241, 60, 42, 0.2)',
       "fill-opacity": 1
     }
  },
  "devPipeline": {
    "id": "devPipeline",
    "type": "circle",
    "source": {
      "type": "vector",
      "url": "mapbox://castmap.cjfctlicp1c1k2qmmedbbu8m4-6sfqw"
    },
    "source-layer": "Development_pipeline_2017_Q3",
    "filter": ['>', 'UNITS', '5'],
    "paint": {
      "circle-radius": {
        "property": "UNITS",
        "type": "step",
        "stops": [
          [10, 10],
          [49, 20],
          [50, 30]
        ]
      },
      "circle-color":  "rgba(241, 60, 42, 0.8)",
      "circle-stroke-width": 2,
      "circle-stroke-color": "#FFF"
    },
    "popup": {
      "title": "Development Pipeline",
      "content": "Address: {NAMEADDR}<br/>Proposed Use: {PROPUSE}<br/>Total Gross SQ FT: {TOTAL_GSF}<br/>Cost: {COST}<br/>Zoning: {ZONING_GEN}<br/>Affordable: {AFFORDABLE}"
    }
  },
  "devPipelineMixeduse": {
    "id": "devPipelineMixeduse",
    "type": "circle",
    "source": {
      "type": "vector",
      "url": "mapbox://castmap.8wq67zf4"
    },
    "source-layer": "Archive-bgu28d",
    "filter": ['all',
      ['==', 'PROJECT_TY', 'Mixres']
    ],
    "paint": {
      "circle-radius": {
        "property": "TOTAL_GSF",
        "type": "exponential",
        "stops": [
          [0, 0],
          [10000, 5],
          [49999, 10],
          [50000, 15]
        ]
      },
      "circle-color":  "rgba(241, 60, 42, 0.8)",
      "circle-stroke-width": 2,
      "circle-stroke-color": "#FFF"
    },
    "popup": {
      "title": "Development Pipeline",
      "content": "Address: {NAMEADDR}<br/>Project Type: {PROJECT_TY}<br/>Units: {UNITS}<br/>Total GSF: {TOTAL_GSF}<br/>Zoning: {ZONING_GEN}<br/>Affordable: {AFFORDABLE}"
    }
  },
  "devPipelineResidential": {
    "id": "devPipelineResidential",
    "type": "circle",
    "source": {
      "type": "vector",
      "url": "mapbox://castmap.8wq67zf4"
    },
    "source-layer": "Archive-bgu28d",
    "filter": ['all',
     ['==', 'PROJECT_TY', 'Resident']
     ],
    "paint": {
      "circle-radius": {
        "property": "UNITS",
        "type": "exponential",
        "stops": [
          [4, 0],
          [5, 5],
          [49, 10],
          [50, 15]
        ]
      },
      "circle-color":  "rgba(241, 60, 42, 0.8)",
      "circle-stroke-width": 2,
      "circle-stroke-color": "#FFF"
    },
    "popup": {
      "title": "Development Pipeline",
      "content": "Address: {NAMEADDR}<br/>Project Type: {PROJECT_TY}<br/>Units: {UNITS}<br/>Zoning: {ZONING_GEN}<br/>Affordable: {AFFORDABLE}"
    }
  },
  "censusWhite": {
     "id": "censusWhite",
     "type": "fill",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.3oe6bf41"
     },
     "source-layer": "polygons-0lyr63",
     "filter": ['has', 'p_white'],
     "paint": {
       "fill-opacity": 0.7,
       "fill-outline-color": "#444",
       "fill-color": {
          "property": "p_white",
          "type": "exponential",
          "stops": [
            [10, "#FFF8D6"],
            [90, "#EDBE17"]
          ]
      }
    }
  },
  "censusWhiteLabels": {
     "id": "censusWhiteLabels",
     "type": "symbol",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.b342rvmk"
     },
     "source-layer": "centroids-dsns0q",
     "filter": ['has', 's_white'],
     "layout": {
        "text-field": "White: {p_white}% ({s_white})",
        "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
        "text-offset": [0, 0.6],
        "text-anchor": "top",
        "text-size": 12
      },
     "paint": {
       "text-halo-color": "#fff",
       "text-halo-width": 1,
       "text-color": "#777"
     }
  },
  "censusOther": {
     "id": "censusOther",
     "type": "fill",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.3oe6bf41"
     },
     "source-layer": "polygons-0lyr63",
     "filter": ['has', 'p_other'],
     "paint": {
       "fill-opacity": 0.7,
       "fill-outline-color": "#444",
       "fill-color": {
          "property": "p_other",
          "type": "exponential",
          "stops": [
            [0, "#FFF8D6"],
            [30, "#EDBE17"]
          ]
      }
    }
  },
  "censusOtherLabels": {
     "id": "censusOtherLabels",
     "type": "symbol",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.b342rvmk"
     },
     "source-layer": "centroids-dsns0q",
     "filter": ['has', 's_other'],
     "layout": {
        "text-field": "Other: {p_other}% ({s_other})",
        "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
        "text-offset": [0, 0.6],
        "text-anchor": "top",
        "text-size": 12
      },
     "paint": {
       "text-halo-color": "#fff",
       "text-halo-width": 1,
       "text-color": "#777"
     }
  },
  "censusHawaiian": {
     "id": "censusHawaiian",
     "type": "fill",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.3oe6bf41"
     },
     "source-layer": "polygons-0lyr63",
     "filter": ['has', 'p_hawaiian'],
     "paint": {
       "fill-opacity": 0.7,
       "fill-outline-color": "#444",
       "fill-color": {
          "property": "p_hawaiian",
          "type": "exponential",
          "stops": [
            [0, "#FFF8D6"],
            [15, "#EDBE17"]
          ]
      }
    }
  },
  "censusHawaiianLabels": {
     "id": "censusHawaiianLabels",
     "type": "symbol",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.b342rvmk"
     },
     "source-layer": "centroids-dsns0q",
     "filter": ['has', 's_hawaiian'],
     "layout": {
        "text-field": "Hawaiian / Pacific Islander: {p_hawaiian}% ({s_hawaiian})",
        "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
        "text-offset": [0, 0.6],
        "text-anchor": "top",
        "text-size": 12
      },
     "paint": {
       "text-halo-color": "#fff",
       "text-halo-width": 1,
       "text-color": "#777"
     }
  },
  "censusNative": {
     "id": "censusNative",
     "type": "fill",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.3oe6bf41"
     },
     "source-layer": "polygons-0lyr63",
     "filter": ['has', 'p_american_indian'],
     "paint": {
       "fill-opacity": 0.7,
       "fill-outline-color": "#444",
       "fill-color": {
          "property": "p_american_indian",
          "type": "exponential",
          "stops": [
            [0, "#FFF8D6"],
            [6, "#EDBE17"]
          ]
      }
    }
  },
  "censusNativeLabels": {
     "id": "censusNativeLabels",
     "type": "symbol",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.b342rvmk"
     },
     "source-layer": "centroids-dsns0q",
     "filter": ['has', 's_american_indian'],
     "layout": {
        "text-field": "Native American: {p_american_indian}% ({s_american_indian})",
        "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
        "text-offset": [0, 0.6],
        "text-anchor": "top",
        "text-size": 12
      },
     "paint": {
       "text-halo-color": "#fff",
       "text-halo-width": 1,
       "text-color": "#777"
     }
  },
  "censusBlack": {
     "id": "censusBlack",
     "type": "fill",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.3oe6bf41"
     },
     "source-layer": "polygons-0lyr63",
     "filter": ['has', 'p_black'],
     "paint": {
       "fill-opacity": 0.7,
       "fill-outline-color": "#444",
       "fill-color": {
          "property": "p_black",
          "type": "exponential",
          "stops": [
            [0, "#FFF8D6"],
            [50, "#EDBE17"]
          ]
      }
    }
  },
  "censusBlackLabels": {
     "id": "censusBlackLabels",
     "type": "symbol",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.b342rvmk"
     },
     "source-layer": "centroids-dsns0q",
     "filter": ['has', 's_black'],
     "layout": {
        "text-field": "Black / African American: {p_black}% ({s_black})",
        "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
        "text-offset": [0, 0],
        "text-anchor": "top",
        "text-size": 12
      },
     "paint": {
       "text-halo-color": "#fff",
       "text-halo-width": 1,
       "text-color": "#777"
     }
  },
  "censusHispanic": {
     "id": "censusHispanic",
     "type": "fill",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.3oe6bf41"
     },
     "source-layer": "polygons-0lyr63",
     "filter": ['has', 'p_hispanic'],
     "paint": {
       "fill-opacity": 0.7,
       "fill-outline-color": "#444",
       "fill-color": {
          "property": "p_hispanic",
          "type": "exponential",
          "stops": [
            [0, "#FFF8D6"],
            [60, "#EDBE17"]
          ]
      }
    }
  },
  "censusHispanicLabels": {
     "id": "censusHispanicLabels",
     "type": "symbol",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.b342rvmk"
     },
     "source-layer": "centroids-dsns0q",
     "filter": ['has', 's_hispanic'],
     "layout": {
        "text-field": "Hispanic / Latino: {p_hispanic}% ({s_hispanic})",
        "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
        "text-offset": [0, 0.6],
        "text-anchor": "top",
        "text-size": 12
      },
     "paint": {
       "text-halo-color": "#fff",
       "text-halo-width": 1,
       "text-color": "#777"
     }
  },
  "censusAsian": {
     "id": "censusAsian",
     "type": "fill",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.3oe6bf41"
     },
     "source-layer": "polygons-0lyr63",
     "filter": ['has', 'p_asian'],
     "paint": {
       "fill-opacity": 0.7,
       "fill-outline-color": "#444",
       "fill-color": {
          "property": "p_asian",
          "type": "exponential",
          "stops": [
            [0, "#FFF8D6"],
            [90, "#EDBE17"]
          ]
      }
    }
  },
  "censusAsianLabels": {
     "id": "censusAsianLabels",
     "type": "symbol",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.b342rvmk"
     },
     "source-layer": "centroids-dsns0q",
     "filter": ['has', 's_asian'],
     "layout": {
        "text-field": "Asian / Asian American: {p_asian}% ({s_asian})",
        "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
        "text-offset": [0, 0],
        "text-anchor": "top",
        "text-size": 12
      },
     "paint": {
        "text-halo-color": "#fff",
        "text-halo-width": 1,
        "text-color": "#777"
     }
  },
  "censusPopulation": {
     "id": "censusPopulation",
     "type": "fill",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.3oe6bf41"
     },
     "source-layer": "polygons-0lyr63",
     "filter": ['has', 'total_population'],
     "paint": {
       "fill-opacity": 0.5,
       "fill-outline-color": "#444",
       "fill-color": {
          "property": "total_population",
          "type": "exponential",
          "stops": [
            [0, "#FFF8D6"],
            [11500, "#EDBE17"]
          ]
      }
    }
  },
  "censusPopulationLabels": {
     "id": "censusPopulationLabels",
     "type": "symbol",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.b342rvmk"
     },
     "source-layer": "centroids-dsns0q",
     "filter": ['has', 'total_population'],
     "layout": {
        "text-field": "Population: {total_population}",
        "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
        "text-offset": [0, 0.6],
        "text-anchor": "top",
        "text-size": 12
      },
     "paint": {
       "text-halo-color": "#fff",
       "text-halo-width": 1,
       "text-color": "#777"
     }
  },
  "censusDensity": {
    "id": "censusDensity",
    "type": "fill",
    "source":{
      "type": "vector",
      "url": "mapbox://castmap.3oe6bf41"
    },
    "source-layer": "polygons-0lyr63",
    "filter": ['has', 'density'],
    "paint": {
      "fill-opacity": 0.5,
      "fill-outline-color": "#444",
      "fill-color": {
         "property": "density",
         "type": "exponential",
         "stops": [
           [0, "#FFF8D6"],
           [30000, "#EDBE17"]
         ]
     }
   }
 },
 "censusDensityLabels": {
    "id": "censusDensityLabels",
    "type": "symbol",
    "source":{
      "type": "vector",
      "url": "mapbox://castmap.b342rvmk"
    },
    "source-layer": "centroids-dsns0q",
    "filter": ['has', 'density'],
    "layout": {
       "text-field": "Density: {density} per sq km",
       "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
       "text-offset": [0, 0.6],
       "text-anchor": "top",
       "text-size": 12
     },
    "paint": {
      "text-halo-color": "#fff",
      "text-halo-width": 1,
      "text-color": "#777"
    }
 },
  "age5": {
     "id": "age5",
     "type": "fill",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.3oe6bf41"
     },
     "transition": {
       "duration": 300,
       "delay": 500
     },
     "source-layer": "polygons-0lyr63",
     "filter": ['has', 'p_age_0_5'],
     "paint": {
       "fill-opacity": 0.5,
       "fill-outline-color": "#444",
       "fill-color": {
          "property": "p_age_0_5",
          "type": "exponential",
          "stops": [
            [0, "#FFF8D6"],
            [10, "#EDBE17"]
          ]
      }
    }
  },
  "age5Labels": {
     "id": "age5Labels",
     "type": "symbol",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.b342rvmk"
     },
     "source-layer": "centroids-dsns0q",
     "filter": ['has', 'p_age_0_5'],
     "layout": {
        "text-field": "0-5 years",
        "text-field": "0-5 years: {p_age_0_5}% ({s_age_0_5})",
        "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
        "text-offset": [0, 0.6],
        "text-anchor": "top",
        "text-size": 12
      },
     "paint": {
       "text-halo-color": "#fff",
       "text-halo-width": 1,
       "text-color": "#777"
     }
  },
  "age20": {
     "id": "age20",
     "type": "fill",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.3oe6bf41"
     },
     "transition": {
       "duration": 300,
       "delay": 500
     },
     "source-layer": "polygons-0lyr63",
     "filter": ['has', 'p_age_5_20'],
     "paint": {
       "fill-opacity": 0.5,
       "fill-outline-color": "#444",
       "fill-color": {
          "property": "p_age_5_20",
          "type": "exponential",
          "stops": [
            [4, "#FFF8D6"],
            [30, "#EDBE17"]
          ]
      }
    }
  },
  "age20Labels": {
     "id": "age20Labels",
     "type": "symbol",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.b342rvmk"
     },
     "source-layer": "centroids-dsns0q",
     "filter": ['has', 's_age_5_20'],
     "layout": {
        "text-field": "5-20 years: {p_age_5_20}% ({s_age_5_20})",
        "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
        "text-offset": [0, 0.6],
        "text-anchor": "top",
        "text-size": 12
      },
     "paint": {
       "text-halo-color": "#fff",
       "text-halo-width": 1,
       "text-color": "#777"
     }
  },
  "age40": {
     "id": "age40",
     "type": "fill",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.3oe6bf41"
     },
     "transition": {
       "duration": 300,
       "delay": 500
     },
     "source-layer": "polygons-0lyr63",
     "filter": ['has', 'p_age_20_40'],
     "paint": {
       "fill-opacity": 0.5,
       "fill-outline-color": "#444",
       "fill-color": {
          "property": "p_age_20_40",
          "type": "exponential",
          "stops": [
            [15, "#FFF8D6"],
            [60, "#EDBE17"]
          ]
      }
    }
  },
  "age40Labels": {
     "id": "age40Labels",
     "type": "symbol",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.b342rvmk"
     },
     "source-layer": "centroids-dsns0q",
     "filter": ['has', 's_age_20_40'],
     "layout": {
        "text-field": "20-40 years: {p_age_20_40}% ({s_age_20_40})",
        "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
        "text-offset": [0, 0.6],
        "text-anchor": "top",
        "text-size": 12
      },
     "paint": {
       "text-halo-color": "#fff",
       "text-halo-width": 1,
       "text-color": "#777"
     }
  },
  "age60": {
     "id": "age60",
     "type": "fill",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.3oe6bf41"
     },
     "transition": {
       "duration": 300,
       "delay": 500
     },
     "source-layer": "polygons-0lyr63",
     "filter": ['has', 'p_age_40_60'],
     "paint": {
       "fill-opacity": 0.5,
       "fill-outline-color": "#444",
       "fill-color": {
          "property": "p_age_40_60",
          "type": "exponential",
          "stops": [
            [8, "#FFF8D6"],
            [35, "#EDBE17"]
          ]
      }
    }
  },
  "age60Labels": {
     "id": "age60Labels",
     "type": "symbol",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.b342rvmk"
     },
     "source-layer": "centroids-dsns0q",
     "filter": ['has', 's_age_40_60'],
     "layout": {
        "text-field": "40-60 years: {p_age_40_60}% ({s_age_40_60})",
        "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
        "text-offset": [0, 0.6],
        "text-anchor": "top",
        "text-size": 12
      },
     "paint": {
       "text-halo-color": "#fff",
       "text-halo-width": 1,
       "text-color": "#777"
     }
  },
  "age80": {
     "id": "age80",
     "type": "fill",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.3oe6bf41"
     },
     "transition": {
       "duration": 300,
       "delay": 500
     },
     "source-layer": "polygons-0lyr63",
     "filter": ['has', 'p_age_60_80'],
     "paint": {
       "fill-opacity": 0.5,
       "fill-outline-color": "#444",
       "fill-color": {
          "property": "p_age_60_80",
          "type": "exponential",
          "stops": [
            [5, "#FFF8D6"],
            [25, "#EDBE17"]
          ]
      }
    }
  },
  "age80Labels": {
     "id": "age80Labels",
     "type": "symbol",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.b342rvmk"
     },
     "source-layer": "centroids-dsns0q",
     "filter": ['has', 's_age_60_80'],
     "layout": {
        "text-field": "60-80 years: {p_age_60_80}% ({s_age_60_80})",
        "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
        "text-offset": [0, 0.6],
        "text-anchor": "top",
        "text-size": 12
      },
     "paint": {
       "text-halo-color": "#fff",
       "text-halo-width": 1,
       "text-color": "#777"
     }
  },
  "age80plus": {
     "id": "age80plus",
     "type": "fill",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.3oe6bf41"
     },
     "transition": {
       "duration": 300,
       "delay": 500
     },
     "source-layer": "polygons-0lyr63",
     "filter": ['has', 'p_age_80_plus'],
     "paint": {
       "fill-opacity": 0.5,
       "fill-outline-color": "#444",
       "fill-color": {
          "property": "p_age_80_plus",
          "type": "exponential",
          "stops": [
            [0, "#FFF8D6"],
            [20, "#EDBE17"]
          ]
      }
    }
  },
  "age80PlusLabels": {
     "id": "age80PlusLabels",
     "type": "symbol",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.b342rvmk"
     },
     "source-layer": "centroids-dsns0q",
     "filter": ['has', 's_age_80_plus'],
     "layout": {
        "text-field": "80+ years: {p_age_80_plus}% ({s_age_80_plus})",
        "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
        "text-offset": [0, 0.6],
        "text-anchor": "top",
        "text-size": 12
      },
     "paint": {
       "text-halo-color": "#fff",
       "text-halo-width": 1,
       "text-color": "#777"
     }
  },
  "income0": {
     "id": "income0",
     "type": "fill",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.3oe6bf41"
     },
     "transition": {
       "duration": 300,
       "delay": 500
     },
     "source-layer": "polygons-0lyr63",
     "filter": ['has', 'p_income_0_25'],
     "paint": {
       "fill-opacity": 0.5,
       "fill-outline-color": "#444",
       "fill-color": {
          "property": "p_income_0_25",
          "type": "exponential",
          "stops": [
            [5, "#FFF8D6"],
            [50, "#EDBE17"]
          ]
      }
    }
  },
  "income0Labels": {
     "id": "income0Labels",
     "type": "symbol",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.b342rvmk"
     },
     "source-layer": "centroids-dsns0q",
     "filter": ['has', 's_income_0_25'],
     "layout": {
        "text-field": "< 25k: {p_income_0_25}% ({s_income_0_25})",
        "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
        "text-offset": [0, 0.6],
        "text-anchor": "top",
        "text-size": 12
      },
     "paint": {
       "text-halo-color": "#fff",
       "text-halo-width": 1,
       "text-color": "#777"
     }
  },
  "income1": {
     "id": "income1",
     "type": "fill",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.3oe6bf41"
     },
     "transition": {
       "duration": 300,
       "delay": 500
     },
     "source-layer": "polygons-0lyr63",
     "filter": ['has', 'p_income_25_50'],
     "paint": {
       "fill-opacity": 0.5,
       "fill-outline-color": "#444",
       "fill-color": {
          "property": "p_income_25_50",
          "type": "exponential",
          "stops": [
            [5, "#FFF8D6"],
            [30, "#FFC600"]
          ]
      }
    }
  },
  "income1Labels": {
     "id": "income1Labels",
     "type": "symbol",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.b342rvmk"
     },
     "source-layer": "centroids-dsns0q",
     "filter": ['has', 's_income_25_50'],
     "layout": {
        "text-field": "25-50k: {p_income_25_50}% ({s_income_25_50})",
        "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
        "text-offset": [0, 0.6],
        "text-anchor": "top",
        "text-size": 12
      },
     "paint": {
       "text-halo-color": "#fff",
       "text-halo-width": 1,
       "text-color": "#777"
     }
  },
  "income2": {
     "id": "income2",
     "type": "fill",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.3oe6bf41"
     },
     "transition": {
       "duration": 300,
       "delay": 500
     },
     "source-layer": "polygons-0lyr63",
     "filter": ['has', 'p_income_50_75'],
     "paint": {
       "fill-opacity": 0.5,
       "fill-outline-color": "#444",
       "fill-color": {
          "property": "p_income_50_75",
          "type": "exponential",
          "stops": [
            [5, "#FFF8D6"],
            [20, "#FFC600"]
          ]
      }
    }
  },
  "income2Labels": {
     "id": "income2Labels",
     "type": "symbol",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.b342rvmk"
     },
     "source-layer": "centroids-dsns0q",
     "filter": ['has', 's_income_50_75'],
     "layout": {
        "text-field": "50-75k: {p_income_50_75}% ({s_income_50_75})",
        "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
        "text-offset": [0, 0.6],
        "text-anchor": "top",
        "text-size": 12
      },
     "paint": {
       "text-halo-color": "#fff",
       "text-halo-width": 1,
       "text-color": "#777"
     }
  },
  "income3": {
     "id": "income3",
     "type": "fill",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.3oe6bf41"
     },
     "transition": {
       "duration": 300,
       "delay": 500
     },
     "source-layer": "polygons-0lyr63",
     "filter": ['has', 'p_income_75_100'],
     "paint": {
       "fill-opacity": 0.5,
       "fill-outline-color": "#444",
       "fill-color": {
          "property": "p_income_75_100",
          "type": "exponential",
          "stops": [
            [2, "#FFF8D6"],
            [25, "#FFC600"]
          ]
      }
    }
  },
  "income3Labels": {
     "id": "income3Labels",
     "type": "symbol",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.b342rvmk"
     },
     "source-layer": "centroids-dsns0q",
     "filter": ['has', 's_income_75_100'],
     "layout": {
        "text-field": "75-100k: {p_income_75_100}% ({s_income_75_100})",
        "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
        "text-offset": [0, 0.6],
        "text-anchor": "top",
        "text-size": 12
      },
     "paint": {
       "text-halo-color": "#fff",
       "text-halo-width": 1,
       "text-color": "#777"
     }
  },
  "income4": {
     "id": "income4",
     "type": "fill",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.3oe6bf41"
     },
     "transition": {
       "duration": 300,
       "delay": 500
     },
     "source-layer": "polygons-0lyr63",
     "filter": ['has', 'p_income_100plus'],
     "paint": {
       "fill-opacity": 0.5,
       "fill-outline-color": "#444",
       "fill-color": {
          "property": "p_income_100plus",
          "type": "exponential",
          "stops": [
            [20, "#FFF8D6"],
            [80, "#FFC600"]
          ]
      }
    }
  },
  "income4Labels": {
     "id": "income4Labels",
     "type": "symbol",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.b342rvmk"
     },
     "source-layer": "centroids-dsns0q",
     "filter": ['has', 's_income_100plus'],
     "layout": {
        "text-field": "100k+: {p_income_100plus}% ({s_income_100plus})",
        "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
        "text-offset": [0, 0.6],
        "text-anchor": "top",
        "text-size": 12
      },
     "paint": {
       "text-halo-color": "#fff",
       "text-halo-width": 1,
       "text-color": "#777"
     }
  },
  "censusTractLines": {
     "id": "censusTractLines",
     "type": "line",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.11qxp198"
     },
     "source-layer": "census-2010-2-34h26z",
     "paint": {
       "line-color": "rgba(120, 112, 88, 0.2)",
       "line-width": 2
      }
    },
  "culturalDistricts": {
     "id": "culturalDistricts",
     "type": "fill",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.duy5uvbi"
     },
     "source-layer": "cultural_districts-0v2jb6",
     "paint": {
       "fill-color": "rgba(241, 60, 42, 0.2)",
     },
     "popup": {
       "title": "Cultural District",
       "content": "<b>{name}</b><br><a target=\"_blank\" href=\"{url}\">More information</a>"
     },
     "hover": {
       "layer": "culturalDistrictsHover",
       "field": "name"
     },
    },
    "culturalDistrictsHover": {
       "id": "culturalDistrictsHover",
       "type": "fill",
       "source":{
         "type": "vector",
         "url": "mapbox://castmap.duy5uvbi"
       },
       "filter": ["has", "nofield"],
       "source-layer": "cultural_districts-0v2jb6",
       "paint": {
         "fill-color": "rgba(241, 60, 42, 0.3)",
       },
      },
  "communityBenefitDistricts": {
     "id": "communityBenefitDistricts",
     "type": "fill",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.62v7emg8"
     },
     "source-layer": "community_benefit_districts-6idf0j",
     "paint": {
       "fill-color": "rgba(241, 60, 42, 0.2)",
     },
     "popup": {
       "title": "Community Benefit District",
       "content": "<b>{cbd}</b><br><a target=\"_blank\" href=\"http://oewd.org/community-benefit-districts\">http://oewd.org/community-benefit-districts</a>"
     },
     "hover": {
       "layer": "communityBenefitDistrictsHover",
       "field": "cbd"
     },
    },
    "communityBenefitDistrictsHover": {
       "id": "communityBenefitDistrictsHover",
       "type": "fill",
       "source":{
         "type": "vector",
         "url": "mapbox://castmap.62v7emg8"
       },
       "filter": ["has", "nofield"],
       "source-layer": "community_benefit_districts-6idf0j",
       "paint": {
         "fill-color": "rgba(241, 60, 42, 0.3)",
       },
      },
  "greenBenefitDistricts": {
     "id": "greenBenefitDistricts",
     "type": "fill",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.13mlvxso"
     },
     "source-layer": "green_benefit_districts-8z26sf",
     "paint": {
       "fill-color": "rgba(241, 60, 42, 0.2)",
     },
     "popup": {
       "title": "Green Benefit District",
       "content": "<b>{gbd}</b><br><a target=\"_blank\" href=\"http://sfpublicworks.org/GBD\">http://sfpublicworks.org/GBD</a><br>The Green Benefit District program seeks to improve the quality of the public realm – the City’s streets, sidewalks, parks and open spaces – within residential and mixed-use neighborhoods. A Green Benefit District provides additional maintenance and capital improvements to parks, sidewalks and open spaces within a designated area, in addition to the City’s existing level of baseline services. The services, improvements and administration of Green Benefit Districts are governed by an independent property owners nonprofit association, representative of the neighborhood."
     },
     "hover": {
       "layer": "greenBenefitDistrictsHover",
       "field": "gbd"
     },
    },
    "greenBenefitDistrictsHover": {
       "id": "greenBenefitDistrictsHover",
       "type": "fill",
       "source":{
         "type": "vector",
         "url": "mapbox://castmap.13mlvxso"
       },
       "filter": ["has", "nofield"],
       "source-layer": "green_benefit_districts-8z26sf",
       "paint": {
         "fill-color": "rgba(241, 60, 42, 0.3)",
       },
      },
  "investInNeighborhoodsDistricts": {
     "id": "investInNeighborhoodsDistricts",
     "type": "fill",
     "source":{
       "type": "vector",
       "url": "mapbox://castmap.6l9q0cwv"
     },
     "source-layer": "Invest_In_Neighborhoods_IIN_A-bzzyd2",
     "paint": {
       "fill-color": "rgba(241, 60, 42, 0.2)",
     },
     "hover": {
       "layer": "investInNeighborhoodsDistrictsHover",
       "field": "corridor"
     },
     "popup": {
       "title": "Invest in Neighborhoods District",
       "content": "<b>{corridor}</b> <br> <a target=\"_blank\" href=\"http://investsf.org/\">http://investsf.org/</a><br>The Invest in Neighborhoods Initiative, one of the 17 points of Mayor Lee’s plan for jobs and economic opportunity, provides focused, customized assistance to meet the specific needs of San Francisco’s neighborhood commercial corridors. Invest in Neighborhoods aims to strengthen and revitalize neighborhood commercial districts around the City by marshaling and deploying resources from across multiple departments and nonprofit partners. These include economic development services such as loan programs, facade improvement grants, and technical assistance for small businesses."
     }
   },
   "investInNeighborhoodsDistrictsHover": {
      "id": "investInNeighborhoodsDistrictsHover",
      "type": "fill",
      "source":{
        "type": "vector",
        "url": "mapbox://castmap.6l9q0cwv"
      },
      "source-layer": "Invest_In_Neighborhoods_IIN_A-bzzyd2",
      "paint": {
        "fill-color": "rgba(241, 60, 42, 0.3)",
      },
      "filter": ["has", "nofield"]
    },
   "buildings": {
      "id": "buildings",
      "type": "fill-extrusion",
      "source":{
        "type": "vector",
        "url": "mapbox://castmap.9ixnnx1i"
      },
      "filter": ['has', 'nofield'],
      "source-layer": "osm_buildings_overpass_2017_0-1sxrzg",
      "paint": {
        "fill-extrusion-color": "#44AFC5",
        "fill-extrusion-height": 20,
        "fill-extrusion-opacity": 0
      },
    },
    "buildingsHover": {
       "id": "buildingsHover",
       "type": "fill-extrusion",
       "source":{
         "type": "vector",
         "url": "mapbox://castmap.9ixnnx1i"
       },
       "source-layer": "osm_buildings_overpass_2017_0-1sxrzg",
       "paint": {
         "fill-extrusion-color": "#44AFC5",
         "fill-extrusion-height": 20,
         "fill-extrusion-opacity": 1
       },
       "filter": ['has', 'nofield']
     },
    "parcels": {
       "id": "parcels",
       "type": "fill-extrusion",

       "source":{
         "type": "vector",
         "url": "mapbox://castmap.9ixnnx1i"
       },
       "source-layer": "osm_buildings_overpass_2017_0-1sxrzg",
       "paint": {
         "fill-extrusion-color": "#FFCD00",
         "fill-extrusion-height": 20,
         "fill-extrusion-opacity": 0.01
       }
     },
     "2percentArts": {
        "id": "2percentArts",
        "type": "fill",
        "source":{
          "type": "vector",
          "url": "mapbox://castmap.6scm5xi4"
        },
        "source-layer": "Zoning_Districts-1l54mp",
        "filter": ['==', 'gen', 'Public'],
        "paint": {
          "fill-color": 'rgba(241, 60, 42, 0.2)',
          "fill-opacity": 1
        }
     },
     "1percentArts": {
        "id": "1percentArts",
        "type": "fill",
        "source":{
          "type": "vector",
          "url": "mapbox://castmap.6scm5xi4"
        },
        "source-layer": "Zoning_Districts-1l54mp",
        "filter": ['any',
         ['==', 'zoning', 'C-3-R'],
         ['==', 'zoning', 'C-3-O'],
         ['==', 'zoning', 'C-3-G'],
         ['==', 'zoning', 'C-3-S'],
         ['==', 'zoning', 'TB-DTR'],
         ['==', 'zoning', 'SB-DTR'],
         ['==', 'zoning', 'SLI'],
         ['==', 'zoning', 'SSO'],
         ['==', 'zoning', 'UMU'],
         ['==', 'zoning', 'WMUG'],
         ['==', 'zoning', 'WMUO'],
         ['==', 'zoning', 'SALI'],
         ['==', 'zoning', 'C-2'],
         ],
         "popup": {
           "title": "1% for Art Requirement",
           "content": "<b>Zone:</b> {zoning}"
         },
        "paint": {
          "fill-pattern": "diagonal-stripes",
          // "fill-color": 'rgba(241, 60, 42, 0.2)',
          "fill-opacity": 0.2
        }
     }
}

export default data



// WEBPACK FOOTER //
// ./src/data/layers.js